module.exports = __webpack_public_path__ + "img/visa.326521cf.png";